import {Logger} from "./Logger";

export function EngagementTimingPlugin() {
    let _logger = Logger();
    let _trackerInstance;
    const loadTimeStamp = Date.now();

    //implementation for methods from Snowplow BrowserPlugin interface
    return {
        activateBrowserPlugin: (tracker) => {
            _trackerInstance = tracker;
            _logger.debug("EngagementTimingPlugin activated on sp instance id and namespace ", tracker.id, tracker.namespace);
        },
        beforeTrack: (payloadBuilder) => {
            payloadBuilder.addContextEntity({
                "schema": "iglu:be.investdata.engagement/page_metrics/jsonschema/1-0-0",
                "data": {"timeOnPage": Math.floor((Date.now() - loadTimeStamp) / 1000)}
            });
        },
        logger: (logger) => _logger = logger
    }
}